const GetInCache = () => {
  return JSON.parse(localStorage.getItem("demande"));
};

export default GetInCache;
